module.exports = __webpack_public_path__ + "img/pick2.1b1cfa9b.png";